import api from './api';
import { ModePaiement, PaiementAvance } from '../types';

export const paiementService = {
  getByCommande: (commandeId: number) =>
    api.get<PaiementAvance[]>(`/api/paiements/commande/${commandeId}`).then((r) => r.data),
  create: (data: { commandeId: number; montant: number; date: string; modePaiement: ModePaiement }) =>
    api.post<PaiementAvance>('/api/paiements', data).then((r) => r.data),
  delete: (id: number) => api.delete(`/api/paiements/${id}`),
};
